/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListUserData } from './genericApiResponseListUserData';
import type { GenericApiResponseListUserMessage } from './genericApiResponseListUserMessage';
import type { GenericApiResponseListUserPagination } from './genericApiResponseListUserPagination';
import type { GenericApiResponseListUserError } from './genericApiResponseListUserError';

export interface GenericApiResponseListUser {
  data?: GenericApiResponseListUserData;
  message?: GenericApiResponseListUserMessage;
  pagination?: GenericApiResponseListUserPagination;
  error?: GenericApiResponseListUserError;
  statusCode?: number;
}
